import { startOfMonth } from 'date-fns';
import { AvailableCurrencies } from 'utils/clickme';
import { previousMonth } from 'utils/date';

import createReducer, { ActionCreatorHelper } from 'store/createReducer';

type IsLoad = boolean;
type CurrentDate = Date;

export interface Summary {
    clickme: {
        count: number;
        sum: number;
    };
    hh: {
        count: number;
        sum: number;
    };
}

export interface ActsSummary {
    auto: Summary;
    manual: Summary;
}

// ----------------------- actions -------------------------------------
const SET_ACTS_SUMMARY = 'SET_ACTS_SUMMARY';
const SET_IS_LOAD_ACTS_SUMMARY = 'SET_IS_LOAD_ACTS_SUMMARY';
const SET_IS_CSV_LOAD_ACTS_SUMMARY = 'SET_IS_CSV_LOAD_ACTS_SUMMARY';
const SET_ACTS_SUMMARY_CURRENT_DATE = 'SET_ACTS_CURRENT_DATE';
const SET_SELECTED_CURRENCY = 'SET_SELECTED_CURRENCY';
const SET_APPLIED_CURRENCY = 'SET_APPLIED_CURRENCY';

interface PayloadTypes {
    [SET_ACTS_SUMMARY]: ActsSummary;
    [SET_IS_LOAD_ACTS_SUMMARY]: IsLoad;
    [SET_IS_CSV_LOAD_ACTS_SUMMARY]: IsLoad;
    [SET_ACTS_SUMMARY_CURRENT_DATE]: CurrentDate;
    [SET_SELECTED_CURRENCY]: AvailableCurrencies;
    [SET_APPLIED_CURRENCY]: AvailableCurrencies;
}

const ActionCreator = ActionCreatorHelper<PayloadTypes>();

export const setActsSummary = ActionCreator(SET_ACTS_SUMMARY);
export const setLoadActsSummary = ActionCreator(SET_IS_LOAD_ACTS_SUMMARY);
export const setCSVLoadActsSummary = ActionCreator(SET_IS_CSV_LOAD_ACTS_SUMMARY);
export const setCurrentDate = ActionCreator(SET_ACTS_SUMMARY_CURRENT_DATE);
export const setSelectedCurrency = ActionCreator(SET_SELECTED_CURRENCY);
export const setAppliedCurrency = ActionCreator(SET_APPLIED_CURRENCY);
// ----------------------- /actions -------------------------------------

// ----------------------- reducer --------------------------------------
interface ActsSummaryState {
    actsSummary: ActsSummary | null;
    isLoad: IsLoad;
    isCSVLoad: IsLoad;
    currentDate: CurrentDate;
    selectedCurrency: AvailableCurrencies;
    appliedCurrency: AvailableCurrencies;
}

const ACTS_SUMMARY_STATE_INITIAL_STATE: ActsSummaryState = {
    actsSummary: null,
    isLoad: false,
    isCSVLoad: false,
    currentDate: startOfMonth(previousMonth),
    selectedCurrency: AvailableCurrencies.RUR,
    appliedCurrency: AvailableCurrencies.RUR,
};

export default createReducer<ActsSummaryState, PayloadTypes>(ACTS_SUMMARY_STATE_INITIAL_STATE, {
    [SET_ACTS_SUMMARY]: (state, { payload }) => ({
        ...state,
        actsSummary: payload,
    }),
    [SET_IS_LOAD_ACTS_SUMMARY]: (state, { payload }) => ({
        ...state,
        isLoad: payload,
    }),
    [SET_IS_CSV_LOAD_ACTS_SUMMARY]: (state, { payload }) => ({
        ...state,
        isCSVLoad: payload,
    }),
    [SET_ACTS_SUMMARY_CURRENT_DATE]: (state, { payload }) => ({
        ...state,
        currentDate: payload,
    }),
    [SET_SELECTED_CURRENCY]: (state, { payload }) => ({
        ...state,
        selectedCurrency: payload,
    }),
    [SET_APPLIED_CURRENCY]: (state, { payload }) => ({
        ...state,
        appliedCurrency: payload,
    }),
});
// ----------------------- /reducer --------------------------------------
